var map = {
	"./boston.jpg": "9471",
	"./daNang.jpg": "fb7c",
	"./daNang2.jpg": "aa93",
	"./haleakala.jpg": "0169",
	"./hochiminh.jpg": "68c9",
	"./kihei.jpg": "bdaa",
	"./krabi.jpg": "788a",
	"./maui.jpg": "becd",
	"./puertoRico.jpg": "6d9a",
	"./seattle.jpg": "a4f1",
	"./seattle2.jpg": "d6da",
	"./stl.jpg": "80f7",
	"./trieste.jpg": "d99a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f169";